import detectBrowserLanguage from "detect-browser-language";
import { supportedLocales, fallbackLocale } from "./supportedLang";

export const LOCALE_PREFERENCE_KEY = "godiway_locale_preference";
export const LOCALE_BROWSER = "browser";

export function getLocalePreference() {
  try {
    return localStorage.getItem(LOCALE_PREFERENCE_KEY) || LOCALE_BROWSER;
  } catch (error) {
    return LOCALE_BROWSER;
  }
}

export function setLocalePreference(preference) {
  try {
    localStorage.setItem(LOCALE_PREFERENCE_KEY, preference);
  } catch (error) {
    // ignore storage errors
  }
}

export function resolveBrowserLocale() {
  const detected = (detectBrowserLanguage() || "").substring(0, 2);
  return Object.keys(supportedLocales).includes(detected)
    ? detected
    : fallbackLocale;
}

export function resolveLocale(preference) {
  if (!preference || preference === LOCALE_BROWSER) {
    return resolveBrowserLocale();
  }

  return Object.keys(supportedLocales).includes(preference)
    ? preference
    : fallbackLocale;
}

export function getInitialLocale() {
  return resolveLocale(getLocalePreference());
}
